











































import Vue from "vue";
import TheAppBar from "@/menu/components/TheAppBar.vue";
import EmptyScreen from "@/common/pages/EmptyScreen.vue";
import StoreSelector from "@/common/components/StoreSelector.vue";
import { storeService } from "@/common/services/StoreService";

export default Vue.extend({
  name: "Scaffold",
  components: { EmptyScreen, TheAppBar, StoreSelector },
  props: {
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillHeightMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillHeightDesktop: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    empty: {
      type: Boolean,
      required: false,
      default: false,
    },
    emptyIcon: {
      type: String,
      required: false,
      default: "mdi-cancel",
    },
    emptyText: {
      type: String,
      required: false,
      default: "common.empty",
    },
    classes: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      storeService,
    };
  },
  methods: {
    hasMobileView(): boolean {
      return this.$slots.mobileView !== undefined;
    },
    setSelected(storeId: string): void {
      if (this.storeService.selectedStore !== storeId) {
        this.storeService.selectedStore = storeId;
      }
    },
  },
});
